import { useEffect, useState } from 'react';
import { closingKeyboardHeight } from './closingKeyboard';

/** The browser's usable rectangle, including keyboard and toolbar changes. A
 *  page field's keyboard closing behind the modal counts as already gone, so
 *  the modal opens where it ends up (closingKeyboard.ts). */
export function useModalViewport() {
  const read = () => ({
    height: Math.max(
      window.visualViewport?.height ?? window.innerHeight,
      closingKeyboardHeight() ?? 0,
    ),
    offsetTop: window.visualViewport?.offsetTop ?? 0,
  });
  const [viewport, setViewport] = useState(read);
  useEffect(() => {
    const update = () => setViewport(read());
    const visible = window.visualViewport;
    window.addEventListener('resize', update);
    visible?.addEventListener('resize', update);
    visible?.addEventListener('scroll', update);
    update();
    return () => {
      window.removeEventListener('resize', update);
      visible?.removeEventListener('resize', update);
      visible?.removeEventListener('scroll', update);
    };
  }, []);
  return viewport;
}
